import Component from '~entry'

export default Component



//////////////////
// WEBPACK FOOTER
// ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js
// module id = null
// module chunks = 